import { NavigationManager } from '@carboncopyco/editor-ui';
import { memo } from 'react';
import { useEditorNavigationModifications } from '../context/EditorSdkProvider';
import { useEditorTool } from '../hooks/useEditorTool';

export const NavigationManagerTool = memo(() => {
  const {
    navigationModifications,
    createNavigationModification,
    editNavigationModification,
    deleteNavigationModification,
    reorderNavigationModification,
    startBlockInteractionsMode,
    createBlockInteractionsSettings,
    blockInteractionsSettings,
  } = useEditorNavigationModifications();
  const { isOpen, close } = useEditorTool('navigation');

  return (
    <NavigationManager
      isOpen={isOpen}
      onClose={close}
      navigationModifications={navigationModifications}
      createNavigationModification={createNavigationModification}
      editNavigationModification={editNavigationModification}
      deleteNavigationModification={deleteNavigationModification}
      reorderNavigationModification={reorderNavigationModification}
      startBlockInteractionsMode={startBlockInteractionsMode}
      blockInteractionsSettings={blockInteractionsSettings}
      createBlockInteractionsSettings={createBlockInteractionsSettings}
    />
  );
});

NavigationManagerTool.displayName = 'NavigationManagerTool';
